




import Pikaday from 'pikaday'
import moment from 'moment'
import Vue from 'vue'

export default {
  name: 'DatePicker'

  props: ['value']

  data: ->
    picker: null

  mounted: ->
    that = @
    @picker = new Pikaday
      field: @$el
      firstDay: 1
      showWeekNumber: true
      format: 'YYYY-MM-DD'
      onSelect: () ->
        that.$emit 'input', that.picker.toString()

  beforeDestroy: ->
    @picker.destroy()

  methods: 
    onInput: (event) ->
      @$emit 'input', event.target.value
  
}




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/form/Datepicker.vue